import { BackendApi } from '../api/api.ts';
import { QueryKey } from '../api/queryKeys.ts';
import { usePartner__createFixedAssetMutation, usePartner__getFixedAssets } from '../generated/blueprint.ts';
import {
    mapFixedAssetFormToApiBody,
    type FixedAssetFormValues,
} from '../pages/app/partner/pages/partnerDashboardPage/components/FixedAssets/fixedAssetForm.ts';

const api = new BackendApi();

export function useClientFixedAssets(clientBusinessId: string) {
    const fixedAssetsQuery = usePartner__getFixedAssets(api, { client_business_id: clientBusinessId }, {
        queryKey: QueryKey.FixedAssets,
    });
    const createMutation = usePartner__createFixedAssetMutation(api, { invalidates: [QueryKey.FixedAssets] });

    return {
        fixedAssets: fixedAssetsQuery.data?.items ?? [],
        isLoading: fixedAssetsQuery.isLoading,
        createFixedAsset: async (values: FixedAssetFormValues): Promise<void> => {
            await createMutation.mutateAsync(mapFixedAssetFormToApiBody(clientBusinessId, values));
        },
    };
}
